module.exports = __webpack_public_path__ + "static/media/toggle_Elipse_Vertical.3ad0a6f7.svg";